//IMPORTANT: When zip codes are updated in the function below, the "Order canceled" email notification and sms will both also have to be updated to account for the new zip codes
//Currently the code that calls this function does not sort the cities or zipcodes in any order, so you can manually do that
//20210211 - Manually sorted cities alphabetically
function getZipcodesJSON() {
	var zip_codes_zones_JSON = getZipCodesAndZoneJSON();

	var zipcodes_json = [];

	var num_areas = zip_codes_zones_JSON.length;
	for(var i = 0; i < num_areas; i++) {
		var area = zip_codes_zones_JSON[i];
		var city = area.city;

		var zip_codes_arr = [];
		var cur_zip_codes = area.zipcodes;
		var num_zip_codes = cur_zip_codes.length;
		for(var j = 0; j < num_zip_codes; j++) {
			zip_codes_arr.push(cur_zip_codes[j][0]);
		}

		zipcodes_json.push({
			city: city
			, zipcodes: zip_codes_arr
		});
	}

	return zipcodes_json;
}

function getZipCodesAndZoneJSON(){
	var zipcodesAndZones = [
		/*20210211 - San Francisco: Referenced https://www.zip-codes.com/city/ca-san-francisco.asp*/
		{
			city: "Brisbane"
			, zipcodes: [
				[94005, 2]
			]
		},
		{
			city: "San Francisco"
			, zipcodes: [
				[94102, 9]
				, [94103, 9]
				, [94104, 10]
				, [94105, 10]
				, [94107, 10]
				, [94108, 10]
				, [94109, 8]
				, [94110, 9]
				, [94111, 10]
				, [94112, 3]
				, [94114, 6]
				, [94115, 8]
				, [94116, 5]
				, [94117, 6]
				, [94118, 7]
				//, [94119, -1] //PO Box with 0 residents
				//, [94120, -1] //PO Box with 0 residents
				, [94121, 7]
				, [94122, 5]
				, [94123, 8]
				, [94124, 2]
				//, [94125, -1] //PO Box with 0 residents
				//, [94126, -1] //PO Box with 0 residents
				, [94127, 3]
				//, [94128 //SFO
				, [94129, 7]
				//, [94130, -1] //Treasure Island
				, [94131, 3]
				, [94132, 4]
				, [94133, 10]
				, [94134, 2]
				//, [94137, -1] //Unique with 0 residents
				//, [94139, -1] //Unique with 0 residents
				//, [94140, -1] //PO Box with 0 residents
				//, [94141, -1] //PO Box with 0 residents
				//, [94142, -1] //PO Box with 0 residents
				//, [94143, -1] //Standard with 0 residents
				//, [94144, -1] //Unique with 0 residents
				//, [94145, -1] //Unique with 0 residents
				//, [94146, -1] //PO Box with 0 residents
				//, [94147, -1] //PO Box with 0 residents
				//, [94151, -1] //Unique with 0 residents
				, [94158, 10]
				//, [94159, -1] //PO Box with 0 residents
				//, [94160, -1] //Unique with 0 residents
				//, [94161, -1] //Unique with 0 residents
				//, [94163, -1] //Unique with 0 residents
				//, [94164, -1] //PO Box with 0 residents
				//, [94172, -1] //PO Box with 0 residents
				//, [94177, -1] //Unique with 0 residents
				//, [94188, -1] //Standard with 0 residents
			]
		},
		{
			city: "South San Francisco"
			, zipcodes: [
				[94080, 1]
				//, [94083, -1] //PO Box with 0 residents
			]
		}
	];

	return zipcodesAndZones;
}

//Param "zipcode" needs to be an integer
//Returns -1 if zipcode cannot be found in zone
function getZipCodeZone(zipcode) {

	var zip_codes_zones_JSON = getZipCodesAndZoneJSON();
	 
	var num_areas = zip_codes_zones_JSON.length;
	for(var i = 0; i < num_areas; i++) {
		var area = zip_codes_zones_JSON[i];
		
		var cur_zip_codes = area.zipcodes;
		var num_zip_codes = cur_zip_codes.length;
		for(var j = 0; j < num_zip_codes; j++) {
			if(cur_zip_codes[j][0] == zipcode) {
				return cur_zip_codes[j][1];
			}
		}
	}

	return -1;
}


//If you are editing zip codes, please edit the code in getZipcodesJSON, as this function pulls its data from there
function getZipcodesArray() {
	var zip_codes_JSON = getZipcodesJSON();

	var zip_codes = [];
	var num_areas = zip_codes_JSON.length;
	for(var i = 0; i < num_areas; i++) {
		var area = zip_codes_JSON[i];
		var cur_zip_codes = area.zipcodes;
		var num_zip_codes = cur_zip_codes.length;
		for(var j = 0; j < num_zip_codes; j++) {
			zip_codes.push(cur_zip_codes[j]);
		}
	}

	return zip_codes;
}